import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Modal } from 'antd';
import { Table as DoodTable, TableContainer } from 'dood-react-components';

import { productActions } from '../../actions';
import { translator } from '../../helpers';
import { tableConstants } from '../../constants/table.constants';

const { confirm } = Modal;

class Table extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: null,
            loading: false
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = options => {
        this.props.dispatch(productActions.table(options)).then(
            result => {
                this.setState({
                    products: result,
                    pagination: result.pagination,
                    filters: result.filters,
                    loading: false
                });
            },
            error => {
                this.setState({ error });
            }
        );
    };

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({ loading: true });

        this.loadData({
            ...this.state.products.options,
            pagination: { ...pagination, current: pagination.current },
            sortField: sorter.columnKey,
            sortOrder: sorter.order,
            filters: filters
        });
    };

    handleStatusChanged = (id, isActive) => {
        this.props.dispatch(productActions.edit(id, { isActive })).then(
            product => {
                const index = this.state.products.data.map(item => {
                    return item.id;
                }).indexOf(product.id);

                if (index < 0) {
                    return;
                }

                this.setState(previousState => {
                    let newData = [...previousState.products.data];

                    const isActive = product.isActive | 0;
                    const oldActionName = isActive
                        ? tableConstants.ACTION_ACTIVATE
                        : tableConstants.ACTION_DEACTIVATE;
                    const newActionName = isActive
                        ? tableConstants.ACTION_DEACTIVATE
                        : tableConstants.ACTION_ACTIVATE;

                    let actions = {};

                    Object.keys(newData[index].actions).forEach(item => {
                        if (item === oldActionName) {
                            actions[newActionName] = newData[index].actions[oldActionName];
                            actions[newActionName].icon = isActive
                                ? tableConstants.ACTION_DEACTIVATE_ICON
                                : tableConstants.ACTION_ACTIVATE_ICON;

                            delete actions[oldActionName];
                        } else {
                            actions[item] = newData[index].actions[item];
                        }
                    });

                    Object.assign(newData[index], { isActive, actions });

                    return {
                        products: { ...this.state.products, data: newData }
                    };
                });
            },
            error => {
                this.setState({ error });
            }
        );
    };

    handleActionClick = (action, data) => {
        switch (action) {
            case tableConstants.ACTION_REMOVE:
                confirm({
                    title: this.props.translate('modal.title.are_you_sure'),
                    okText: this.props.translate('label.yes'),
                    okType: 'danger',
                    cancelText: this.props.translate('label.no'),
                    onOk: () => {
                        return this.handleDelete(data.id);
                    }
                });
                break;

            case tableConstants.ACTION_ACTIVATE:
            case tableConstants.ACTION_DEACTIVATE:
                this.handleStatusChanged(data.id, !data.isActive);
                break;

            default:
                break;
        }
    };

    handleDelete = id => {
        return new Promise((resolve, reject) => {
            this.props.dispatch(productActions.remove(id)).then(
                () => {
                    const data = this.state.products.data.filter(product => product.id !== id);

                    this.setState(previousState => ({
                        products: { ...previousState.products, data }
                    }));

                    resolve();
                },
                error => {
                    this.setState({ error });

                    reject();
                }
            );
        });
    };

    render() {
        const { products, loading } = this.state;

        let tableComponent = null;

        if (products) {
            const { data, columns, filters, pagination } = products;

            tableComponent = (
                <DoodTable
                    translate={this.props.translate}
                    loading={loading}
                    data={data}
                    columns={columns}
                    filters={filters}
                    pagination={pagination}
                    onActionClick={this.handleActionClick}
                    onTableChange={this.handleTableChange}
                />
            );
        }

        return (
            <TableContainer
                translate={this.props.translate}
                title={this.props.translate('title.products')}
                tableComponent={tableComponent}
                error={this.state.error}
                createRoute='/products/create'
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        translate: translator(state)
    };
};

export default connect(mapStateToProps)(Table);
